import { Component, Input } from "@angular/core";
import { ProcessingResultsContainerContexts } from "../processing-result-container/processing-result-container.component";
import { LABELS } from "./config/wording";
import { PROCESSING_WORDING } from "libraries/service/processing/processing.service";
import { IMinimalProcessing } from "app_sasha/shared/resources/processings/IMinimalProcessing";
import { ILabels } from "libraries/interfaces/ILabels";
import { DateService } from "libraries/date/date.service";
import { faEye, IconDefinition } from "@fortawesome/free-regular-svg-icons";

@Component({
    selector: 'processing',
    template: `
        <div class="col-to-row-s-tb processing hoverarea">
            <div class="round sep-right nb-booking">{{nbBooking()}}</div>
            <div class="flex-3" [class.col-to-row-s-tb]="context === 'search-result'">
                <permission path="sasha.processing.detail.view" class="flex-1">
                    <div class="has-permission">
                        <a [routerLink]="getProcessingDetailLink()">
                            <strong *ngIf="processing.type">{{processingTypes[processing.type]}} : </strong>
                            <span *ngIf="processing.title">{{processing.title}}</span>
                        </a>
                    </div>
                    <div class="has-no-permission">
                        <strong *ngIf="processing.type">{{processingTypes[processing.type]}} : </strong>
                        <span *ngIf="processing.title">{{processing.title}}</span>
                    </div>
                </permission>
                <div class="flex-1">
                    <div *ngIf="processing.whenLastUpdated" [title]="labels.whenLastUpdated" class="e2e-date-send-email">
                        {{processing.whenLastUpdated | dateMoment:dateService.dateFormats.momentShort}} -
                        {{processing.whenLastUpdated | dateMoment:dateService.dateFormats.momentTime}}
                    </div>
                </div>
            </div>
            <expandable-processing-status class="flex-1"
                                          [expand]="expand"
                                          [statusList]="processing.status"
            ></expandable-processing-status>
            <div class="sep-left" *ngIf="context === 'search-result'">
                <btn type="actionDo" (click)="expand = !expand">
                    <span class="icon"><fa-icon [icon]="faEye"></fa-icon></span>
                </btn>
            </div>
        </div>
    `,
    styleUrls: ['./processing.component.scss'],
})
export class ProcessingComponent {
    @Input()
    public processing: IMinimalProcessing;

    @Input()
    public context: ProcessingResultsContainerContexts;

    public readonly processingTypes: { [key: string]: string } = PROCESSING_WORDING;

    public readonly labels: ILabels = LABELS;

    public readonly faEye: IconDefinition = faEye;

    public expand: boolean = false;

    constructor(public readonly dateService: DateService) {
    }

    public nbBooking(): number {
        return Object.values(this.processing.status)
            .reduce((accumulator: number, currentValue: number) =>
                accumulator + (currentValue ? currentValue : 0));
    }

    public getProcessingDetailLink(): string[] {
        return ['/sasha', 'processing', this.processing.id.toString()];
    }
}
